// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — mode-selector.styled.classic.js, новая — mode-selector.styled.cp.js
import { isCp } from 'libs/design';
import * as classic from './mode-selector.styled.classic';
import * as cp from './mode-selector.styled.cp';

export const Content = isCp ? cp.Content : classic.Content;
export const CurrentMode = isCp ? cp.CurrentMode : classic.CurrentMode;
export const Explanation = isCp ? cp.Explanation : classic.Explanation;
export const Title = isCp ? cp.Title : classic.Title;
